import { AxiosPromise } from 'axios';
import _ from 'lodash';
import axios from '@/axios';
import { SupplierFields, SupplierParams } from '@/model/suppliers-choices';
import { Service } from '@/model/service';

const servicesService = {
    getAll(): AxiosPromise<Service[]> {
        return axios.get('/services');
    },
    getWithParams(supplierParams: SupplierParams): AxiosPromise<Service[]> {
        const params = new  URLSearchParams({});

        _.each(
            [
                SupplierFields.suppliers,
                SupplierFields.countries,
                SupplierFields.products,
                SupplierFields.contracts,
            ],
            (param) => {
                const data = supplierParams[param];
                if (data && data?.length) {
                    params.append(param, data.join(','));
                }
            }
        );

        return axios.get(
            `/services`,
            {
                params
            }
        );
    },
}

export default servicesService;